export enum StrictlyCookies {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
